<template>
  <div class="main-container">
    <div class="main-header">
      <div class="logo-box">
        <img src="/images/logo.png" alt="">
      </div>
      <div class="name-box">婴幼儿认知量表统计分析系统</div>
      <topMenu :num="2"></topMenu>
    </div>
    <div class="main-body column">
      <div class="header">
        <div class="title-box"><img src="/images/input-header-icon.png" alt=""><span class="name">基本信息</span></div>
      </div>
      <div class="body">
        <div class="de" style="margin:0 0 40px 0;font-size: 14px">ps: <span style="color: #577AAC">*</span>为必填项
        </div>
        <a-form-model ref="form" :model="formModel" :rules="formRules" autoComplete="off" :label-col="labelCol"
          :wrapper-col="wrapperCol" labelAlign="left">
          <a-row>
            <a-col :span="12">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="记分编号" prop="scoring_num">
                    <div class="flex">
                      <a-input class="cu-input1" v-model="formModel.scoring_num" disabled />
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="姓名" prop="name">
                    <div class="flex">
                      <a-input allowClear class="cu-input1" v-model="formModel.name" />
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="性别" prop="gender">
                    <div class="flex" style="margin-top: 10px">
                      <a-radio-group v-model="formModel.gender">
                        <a-radio :value="1">男</a-radio>
                        <a-radio :value="2">女</a-radio>
                      </a-radio-group>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="测试日期" prop="test_date">
                    <a-date-picker allowClear format="YYYY-MM-DD" style="width: 100%" class="cu-input1"
                      v-model="formModel.test_date" @change="computingRealAge" />
                  </a-form-model-item>
                  <a-form-model-item label="出生日期" prop="born_date">
                    <a-date-picker :disabled-date="disabledBornDate" @change="computingRealAge" allowClear
                      format="YYYY-MM-DD" style="width: 100%" class="cu-input1" v-model="formModel.born_date" />
                  </a-form-model-item>
                  <a-form-model-item label="测试年龄" prop="children.real_age">
                    <a-input class="cu-input1" disabled placeholder="选择测试日期和出生日期后自动计算" v-model="formModel.real_age" />
                  </a-form-model-item>
                  <a-form-model-item label="是否早产儿" prop="is_premature_infant">
                    <div class="flex" style="margin-top: 10px">
                      <a-radio-group v-model="formModel.is_premature_infant" :disabled="isAgeOver24Months">
                        <a-radio :value="0">否</a-radio>
                        <a-radio :value="1">是</a-radio>
                      </a-radio-group>
                    </div>
                    <div v-if="isAgeOver24Months" style="color: #ff4d4f; font-size: 12px; margin-top: 5px;">
                      测试年龄达到24个月，不再进行早产儿矫正
                    </div>
                  </a-form-model-item>
                  <template v-if="formModel.is_premature_infant === 1">
                    <a-form-model-item label="预产日期" prop="expected_date">
                      <a-date-picker allowClear format="YYYY-MM-DD" style="width: 100%" class="cu-input1"
                        v-model="formModel.expected_date" @change="computingRealAge" />
                    </a-form-model-item>
                    <a-form-model-item label="矫正后测试年龄" prop="adjustment_age">
                      <a-input class="cu-input1" disabled placeholder="选择测试日期与预产日期后将自动计算"
                        v-model="formModel.adjustment_age" />
                    </a-form-model-item>
                  </template>
                  <a-form-model-item label="主试姓名" prop="examiner_name">
                    <div class="flex">
                      <a-input class="cu-input1" v-model="formModel.examiner_name" disabled />
                    </div>
                  </a-form-model-item>
                  <!--                  <a-form-model-item label="所在年级" prop="grade">
                                      <a-select placeholder="请选择" v-model="formModel.grade">
                                        <a-select-option value="幼儿园大班">幼儿园大班</a-select-option>
                                        <a-select-option value="学前班">学前班</a-select-option>
                                        <a-select-option value="小学一年级">小学一年级</a-select-option>
                                        <a-select-option value="小学二年级">小学二年级</a-select-option>
                                        <a-select-option value="小学三年级">小学三年级</a-select-option>
                                        <a-select-option value="小学四年级">小学四年级</a-select-option>
                                        <a-select-option value="小学五年级">小学五年级</a-select-option>
                                        <a-select-option value="小学六年级">小学六年级</a-select-option>
                                        <a-select-option value="初中一年级">初中一年级</a-select-option>
                                        <a-select-option value="初中二年级">初中二年级</a-select-option>
                                        <a-select-option value="初中三年级">初中三年级</a-select-option>
                                        <a-select-option value="高中一年级">高中一年级</a-select-option>
                                        <a-select-option value="高中二年级">高中二年级</a-select-option>
                                        <a-select-option value="高中三年级">高中三年级</a-select-option>
                                      </a-select>
                                    </a-form-model-item>-->
                </a-col>
              </a-row>
            </a-col>
            <a-col :span="11" class="right-box">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="照护者姓名">
                    <div class="flex">
                      <a-input allowClear class="cu-input1" v-model="formModel.caregivers_name" />
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="与儿童关系">
                    <a-select placeholder="请选择" v-model="formModel.relationship_of_child">
                      <a-select-option value="FATHER">父亲</a-select-option>
                      <a-select-option value="MONTHER">母亲</a-select-option>
                      <a-select-option value="GRAND_FATHER">（外）祖父母</a-select-option>
                      <a-select-option value="OTHER">其他</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row v-if="formModel.relationship_of_child === 'OTHER'">
                <a-col :span="24">
                  <a-form-model-item label="与儿童关系补充">
                    <div class="flex">
                      <a-input allowClear class="cu-input1" v-model="formModel.relationship_remark" />
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="认知转介原因"
                    :label-col="{ span: 12, style: { color: '#7E8589', fontWeight: '500' } }"
                    :wrapper-col="{ span: 12 }">
                    <div class="flex">
                      <a-textarea allowClear class="cu-input1" v-model="formModel.referral_remark"
                        :auto-size="{ minRows: 6, maxRows: 6 }" style="min-height: 80px;" />
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 40px;margin-top: 10px"></div>
          <div style="display: flex;align-items: center;justify-content: center;cursor: pointer">
            <div class="btn" @click="actionData">提交</div>
          </div>
        </a-form-model>
      </div>
    </div>
    <footer-bottom></footer-bottom>
  </div>
</template>

<script>
import * as Api from './api';
import * as commonApi from '@/commonApi';
import { message } from "ant-design-vue";
import { FindScoringNum, GetRealAge } from "./api";
import moment from "moment";

export default {
  data() {
    return {
      labelCol: { span: 6, style: { color: '#7E8589', fontWeight: '500' } },
      wrapperCol: { span: 16 },
      formModel: {
        archives_num: '',
        scoring_num: '',
        name: '',
        examiner_name: '',
        gender: 1,
        is_minorities: 1,
        hand_habit: 2,
        exam_address: '',
        born_date: '',
        real_age: '',
        remark: '',
        certificate_no: '',
        grade: undefined,
        parent_culture: undefined,
        is_premature_infant: 0,
        adjustment_age: '',
        so_referral_remark: '',
        isAgeOver24Months: false, // 新增变量，用于判断年龄是否超过24个月
        realAgeMonths: 0, // 新增变量，存储实际月龄
      },
      formRules: {
        scoring_num: [
          { required: true, message: '请生成记分编号', trigger: 'change' },
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'change' },
        ],
        examiner_name: [
          { required: true, message: '请获取主试姓名', trigger: 'change' },
        ],
        gender: [
          { required: true, message: '请选择性别', trigger: 'change' },
        ],
        test_date: [
          { required: true, message: '请选择测试日期', trigger: 'change' },
        ],
        is_premature_infant: [
          { required: true, message: '请选择是否早产儿', trigger: 'change' },
        ],
        expected_date: [
          { required: true, message: '请选择预产日期', trigger: 'change' },
        ],
        adjustment_age: [
          { required: true, message: '请计算矫正后测试年龄', trigger: 'change' },
        ],
        born_date: [
          { required: true, message: '请选择出生日期', trigger: 'change' },
        ],
        exam_address: [
          { required: true, message: '请输入测试地点', trigger: 'change' },
        ],
        real_age: [
          { required: true, message: '请选择出生日期后生成实际年龄', trigger: 'change' },
        ],
      },
    };
  },
  mounted() {
    this.getInfo();
    this.findScoringNum();
  },
  methods: {
    disabledDate(current) {
      return moment(current).format('L') > moment(new Date()).format('L')
    },
    // 新增方法：限制出生日期不能大于测试日期
    disabledBornDate(current) {
      // 首先不能大于当前日期
      const isAfterToday = moment(current).format('L') > moment(new Date()).format('L');

      // 其次不能大于已选择的测试日期（如果已选择）
      const isAfterTestDate = this.formModel.test_date &&
        moment(current).format('L') > moment(this.formModel.test_date).format('L');

      return isAfterToday || isAfterTestDate;
    },

    // 新增方法：处理测试日期变更
    handleTestDateChange(date) {
      // 如果出生日期已选择且大于测试日期，则清空出生日期
      if (this.formModel.born_date && date) {
        if (moment(this.formModel.born_date).isAfter(date)) {
          this.formModel.born_date = null;
          this.formModel.real_age = "";
          message.warning({ content: '出生日期不能大于测试日期，已清空出生日期' });
        }
      }

      // 调用原有的计算方法
      this.computingRealAge();
    },

    validateAge(result) {
      // 根据字符串的结果进行验证
      if (
        result === '' ||
        result.includes('岁0个月') ||
        result.includes('0岁') && result.includes('个月') && parseInt(result.split('个月')[1]) < 16
      ) {
        message.error({ content: '测试年龄必须不能小于0个月16天' });
        return false;
      }
      const [yearsStr, monthsStr, daysStr] = result.split(/[岁个月天]/);
      const years = parseInt(yearsStr, 10) || 0;
      const months = parseInt(monthsStr, 10) || 0;
      const days = parseInt(daysStr, 10) || 0;
      // if (
      //     years > 3 ||
      //     (years === 3 && months > 6) ||
      //     (years === 3 && months === 6 && days > 30)
      // ) {
      //   message.error({content: '测试年龄必须不能大于3岁6个月30天'});
      //   return false;
      // }
      return true;
    },
    async actionData() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          if (this.validateAge(this.formModel.real_age)) {
            window.localStorage.setItem('base_info', JSON.stringify(this.formModel));
            this.$router.push({ path: '/select-age' })
          }
        }
      });
    },
    goSelectAge() {
      this.$router.push({ path: '/select-age' })
    },
    async getInfo() {
      const res = await Api.GetInfo({});
      if (res && res.code == 0) {
        this.formModel.examiner_name = res.chiefExaminer.name;
        this.formModel.certificate_no = res.chiefExaminer.certificate_no;
      }
    },
    async findScoringNum() {
      const res = await Api.FindScoringNum({});
      if (res && res.code == 0) {
        this.formModel.scoring_num = this.formModel.certificate_no + res.scoringNum;
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const result = `${year}-${month}-${day}`;
      return result;
    },
    // 年龄限时转换
    converAge(input) {
      const parts = input.split(':');
      const firstPart = parseInt(parts[0], 10);
      const secondPart = parseInt(parts[1], 10);
      let years = 0;
      let months = 0;
      let days = 0;
      if (firstPart >= 12) {
        // years = Math.floor(firstPart / 12);
        months = firstPart;
      } else {
        months = firstPart;
      }
      days = secondPart;
      let result = '';
      if (years > 0) {
        result += `${years}岁`;
      }
      if (months > 0) {
        result += `${months}个月`;
      }
      if (days > 0) {
        result += `${days}天`;
      }
      return result;
    },
    async computingRealAge() {
      if (this.formModel.test_date && this.formModel.born_date) {
        const res = await GetRealAge({
          born_time: this.formatDate(this.formModel.born_date.toDate()),
          test_date: this.formatDate(this.formModel.test_date.toDate())
        });
        if (res && res.code == 0) {
          this.formModel.real_age = this.converAge(res.realAgeValue);

          // 解析realAgeValue，判断月龄是否大于等于24个月
          const parts = res.realAgeValue.split(':');
          const months = parseInt(parts[0], 10);
          this.realAgeMonths = months;
          this.isAgeOver24Months = months >= 24;

          // 如果月龄大于等于24个月，且早产儿选择为"是"，则自动改为"否"
          if (this.isAgeOver24Months && this.formModel.is_premature_infant === 1) {
            this.formModel.is_premature_infant = 0;
            this.formModel.adjustment_age = ""; // 清空调整后测试年龄
            message.info('测试年龄达到24个月，已自动设置为非早产儿');
          }
        }
      }
      if (!this.formModel.test_date) {
        this.formModel.real_age = "";
        this.formModel.adjustment_age = "";
        this.isAgeOver24Months = false;
      }
      if (!this.formModel.born_date) {
        this.formModel.real_age = "";
        this.isAgeOver24Months = false;
      }
      if (this.formModel.test_date && this.formModel.expected_date) {
        const res = await GetRealAge({
          born_time: this.formatDate(this.formModel.expected_date.toDate()),
          test_date: this.formatDate(this.formModel.test_date.toDate())
        });
        if (res && res.code == 0) {
          this.formModel.adjustment_age = this.converAge(res.realAgeValue);
        }
      }
      if (!this.formModel.expected_date) {
        this.formModel.adjustment_age = "";
      }
    },

    changeBornTime(e, s) {
      this.formModel.born_date = s;
    }

  }
};
</script>
<style></style>
<style scoped>
.main-body {
  background-image: url("/images/maintain-bg.png");
  align-items: flex-start;
  justify-content: flex-start;
}

.line1 {
  border: 1px solid #f8f8f8;
  margin-bottom: 20px;
}

.ant-form-item-control .ant-form-item-children {
  display: flex;
}

.num-de {
  font-size: 12px;
  font-weight: 400;
  color: #999A9A;
  width: 100px;
  text-align: center;
}

.flex {
  display: flex;
}

.right-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  border-left: 1px solid #eee;
  padding-left: 70px;
  justify-content: flex-start;
}

.right-title {
  font-size: 14px;
  font-weight: 600;
  color: #577AAC;
  margin-bottom: 20px;
}

.cu-select {
  line-height: 42px;
  height: 42px;
}

.btn {
  background: #577AAC;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 45px;
  text-align: center;
  cursor: pointer;
  padding: 0 40px;
}

.btn.sh {
  border: 1px solid #577AAC;
  border-radius: 5px;
  font-weight: 400;
  color: #577AAC;
  line-height: 45px;
  background: #FFFFFF;
  display: inline;
  display: flex;
  align-items: center;
}

.ant-form-item {
  margin-bottom: 12px !important;
}
</style>
